import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usersService } from '@/services';

export function useDeactivateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (email: string) => {
      const result = await usersService.deactivateUser(email);
      if (!result.success)
        throw new Error(result.error || 'Falha ao desativar');
      return result.message;
    },
    onMutate: async email => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: ['users'] }),
        queryClient.cancelQueries({ queryKey: ['advisories-users'] }),
        queryClient.cancelQueries({ queryKey: ['brokers-users'] }),
      ]);
      const prev = queryClient.getQueriesData<{ data?: any[]; meta?: any }>({
        queryKey: ['users'],
      });
      prev.forEach(([key, data]) => {
        if (!data?.data) return;
        const next = {
          ...data,
          data: data.data.map(u =>
            (u.email || u.id) === email
              ? {
                  ...u,
                  status: 'INACTIVE',
                  deactivated_at: new Date().toISOString(),
                }
              : u
          ),
        };
        queryClient.setQueryData(key as any, next);
      });
      return { prev };
    },
    onError: (_err, _email, context) => {
      if (!context) return;
      context.prev.forEach(([key, data]) => {
        queryClient.setQueryData(key as any, data);
      });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.refetchQueries({ queryKey: ['users'] }),
        queryClient.refetchQueries({ queryKey: ['advisories-users'] }),
        queryClient.refetchQueries({ queryKey: ['brokers-users'] }),
      ]);
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['users'] }),
        queryClient.invalidateQueries({ queryKey: ['advisories-users'] }),
        queryClient.invalidateQueries({ queryKey: ['brokers-users'] }),
      ]);
    },
  });
}
